<template>
  <div class="loading-spinner">
    <div class="loader" :class="{'loader--active' : IsLoaderActive}">
      <loadingIcon :shown="IsLoaderActive" />
      <div class="loader__tile" :style="{backgroundColor : Color }" v-for="n in 5" :key="n"></div>
    </div>
    <verticalProgressbar v-if="!$isMobile()" :value="30" />
  </div>
</template>

<script>
import verticalProgressbar from "../verticalProgressbar";
import common from "../../mixins/CommonFunctions";
import loadingIcon from "./loadingIcon";

export default {
  components: {
    verticalProgressbar,
    loadingIcon,
  },
  mixins: [common],
  data: function () {
    return {
      IsLoaderActive: false,
    };
  },
  props: ["Color"],
  mounted: function () {
    this.$router.beforeEach((to, from, next) => {
      this.IsLoaderActive = true;
      this.$forceUpdate();
      setTimeout(() => {
        next();
      }, 3000);
    });

    this.$router.afterEach(() => {
      this.IsLoaderActive = false;
      this.$forceUpdate();
    });
  },

  methods: {},
};
</script>

<style>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 100vh;
  transition: width 0s 1.4s ease;
  z-index: 9999998;
}
.loader .loader__tile {
  position: absolute;
  left: 0;
  width: 0;
  height: 20%;
  background-color: #007ae5;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-image: linear-gradient(#a43931, #182848);
  transition: width 0.7s ease;
}
.loader .loader__tile:nth-child(0) {
  top: calc(-1 * 20%);
  transition-delay: -0.2s;
}
.loader .loader__tile:nth-child(1) {
  top: calc(0 * 20%);
  transition-delay: 0s;
}
.loader .loader__tile:nth-child(2) {
  top: calc(1 * 20%);
  transition-delay: 0.2s;
}
.loader .loader__tile:nth-child(3) {
  top: calc(2 * 20%);
  transition-delay: 0.4s;
}
.loader .loader__tile:nth-child(4) {
  top: calc(3 * 20%);
  transition-delay: 0.6s;
}
.loader .loader__tile:nth-child(5) {
  top: calc(4 * 20%);
  transition-delay: 0.8s;
}
.loader--active {
  width: 100%;
  transition-delay: 0s;
}
.loader--active .loader__icon {
  opacity: 1;
  transition: opacity 0.5s 1.4s ease;
}
.loader--active .loader__tile {
  width: 100%;
}
.loader--active .loader__tile:nth-child(0) {
  transition-delay: -0.2s;
}
.loader--active .loader__tile:nth-child(1) {
  transition-delay: 0s;
}
.loader--active .loader__tile:nth-child(2) {
  transition-delay: 0.2s;
}
.loader--active .loader__tile:nth-child(3) {
  transition-delay: 0.4s;
}
.loader--active .loader__tile:nth-child(4) {
  transition-delay: 0.6s;
}
.loader--active .loader__tile:nth-child(5) {
  transition-delay: 0.8s;
}
</style>